import React, { Component }      from "react";

const SvgIcon = () =>
{
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" ><defs></defs><title>close</title><g id="Layer_2" data-name="Layer 2"><g id="SVGs"><polygon className="cls-10000" points="35 1.44 33.57 0 17.5 16.07 1.43 0 0 1.44 16.07 17.5 0 33.57 1.43 35 17.5 18.93 33.57 35 35 33.57 18.93 17.5 35 1.44"/><rect className="cls-2" width="35" height="35"/></g></g></svg>
}

export default SvgIcon;
